import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { getExtensionRules } from '../../../../shared/all-extension-rules';

@Component({
  selector: 'checkout-content-restrictions',
  templateUrl: './checkout-content-restrictions.component.html',
  standalone: false,
})
export class CheckoutContentRestrictionsComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;
  @Input() shopCurrencySymbol: string;
  readonly formArrayFieldName = 'restrictionsRules';
  entities;
  restrictionsRules = getExtensionRules();

  constructor() {}

  ngOnInit() {
    this.entities = this.restrictionsRules.map((r) => r.entity);
  }
}
